import { HTTPClient } from "@abaco/web-common/src/HTTP";
import { PagedResults } from "@abaco/web-common/src/Paging";
import { PlotCouncil, PlotProvince, RiskAdversity, RiskAnalysis, RiskRequest } from "../models/RiskAnalysesModel";

export default class EmergencyAnalysesApi {
  http: HTTPClient;

  constructor(http: HTTPClient) {
    this.http = http;
  }

  async getProvinces(pkCuaa: number, includeSupplyChain = false) {
    const res = await this.http.get<PagedResults<PlotProvince>>(`/sitiagri-rest-api/api_basic/v1/plots/subjects/${pkCuaa}/dictionary_provinces`, {
      params: {
        include_supply_chain: includeSupplyChain, 
        count: 300,
      }
    });
    return res.data.records;
  }

  async getCouncilWithMbr(councilId: number) {
    const res = await this.http.get<PagedResults<PlotCouncil>>(`/sitiagri-rest-api/api_basic/v1/plots/dictionary_councils`, {
      params: {
        filter: `council_id eq ${councilId}`,
        get_mbr: true,
        administrative_tree: true
      }
    })
    return res.data.count >= 1 ? res.data.records[0] : null;
  }

  async getAdversitiesRisks() {
    const res = await this.http.get<RiskAdversity[]>("/sitiagri-rest-api/api_basic/v1/dss/adversities_risk");
    return res.data;
  }

  async getRisks(pkCuaa: number, campaign: number) {
    const res = await this.http.get<RiskAnalysis[]>(`/risk-analysis-api/api-priv/v1/analyses/subjects/${pkCuaa}/campaign/${campaign}`);
    return res.data;
  }

  async removeRisk(pkCuaa: number, campaign: number, analysisId: number) {
    const res = await this.http.delete(`/risk-analysis-api/api-priv/v1/analyses/subjects/${pkCuaa}/campaign/${campaign}/${analysisId}`);
    return res.data;
  }

  async getLastRisk(pkCuaa: number, campaign: number, SCLeaderId?: number): Promise<Record<string, RiskAnalysis>> {
    const params = {
      SCLeaderId
    }
    const res = await this.http.get<Record<string, RiskAnalysis>>(`/risk-analysis-api/api-priv/v1/analyses/subjects/${pkCuaa}/campaign/${campaign}/last`, {params});
    return res.data;
  }

  async addRisk(risk: RiskRequest) {
    const res = await this.http.post<RiskAnalysis[]>(`/risk-analysis-api/api-priv/v1/analyses/`, risk);
    return res.data;
  }
}
